var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPrev(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.186 5.048l.001.26c0 1.084-.063 2.072-.159 2.716l-.083.4c-.047.213-.108.454-.172.577-.233.451-.69.73-1.179.73h-.042c-.628-.02-1.366-.457-1.912-.768-1.09-.62-2.462-1.584-3.19-2.322l-.28-.292a2.638 2.638 0 01-.205-.246 1.303 1.303 0 01-.256-.784c0-.311.096-.6.277-.838l.286-.31.064-.065c.87-.945 3.144-2.49 4.334-2.963l.18-.069c.215-.078.518-.17.702-.178.233 0 .456.054.669.16.266.151.477.388.595.667.193.5.246 1.049.294 1.584.044.501.07 1.1.076 1.74zm5.765.266c0 .617-.495 1.117-1.106 1.117l-2.721-.24a.872.872 0 01-.868-.877c0-.485.389-.877.868-.877l2.721-.24c.61 0 1.106.5 1.106 1.117z",
    fill: "#200E32",
    fillOpacity: 0.75
  })));
}

export default __webpack_public_path__ + "96b231d3a3e81a49526eaa755c02a864.svg";
export { SvgPrev as ReactComponent };